import { Modal, Row, Col, Button } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { useQuery } from "react-query";
import { rotateImage } from '../../../api/index';
import { ClipLoader } from "react-spinners";
import { checkForAPISuccess, responseToastHandler, showErrorToast } from "../../../Common/commonFunctions";
import { useDispatch, useSelector } from "react-redux";
import { ROTATE_COMPONENT_IMAGE, ROTATE_EQUIPMENT_IMAGE } from "../../../store/actions";
import ReactImageGallery from "react-image-gallery";
import { IMAGE_OPTIONS_TYPE } from "../../../Common/constants";
import { Icon } from "@iconify/react";

const ImagePopup = props => {

    const ref = useRef();
    const dispatch = useDispatch();
    const [utils, setUtils] = useState({ rotation: 0 });
    const useQueryConfiguration = {
        enabled: false, retry: false, retryOnMount: false,
        refetchOnMount: false, refetchOnWindowFocus: false
    }
    const isLockedProfile = useSelector(state => state.equipment.isLockedProfile);
    const isEditOngoing = useSelector(state => state.equipment.isEditOngoing);

    const rotateImageFn = async () => {
        const response = await rotateImage({ link: props.image, degree: utils.rotation });
        if(checkForAPISuccess(response?.data?.statusCode)) {
            dispatch({
                type: props.target === IMAGE_OPTIONS_TYPE[0] ? ROTATE_EQUIPMENT_IMAGE : ROTATE_COMPONENT_IMAGE,
                payload: { link: response.data.data, id: props.imageId }
            });
            responseToastHandler(response?.data?.statusCode, null, { message: "Image rotated successfully", callBack: () => {} }, null);
        }
        else {
            showErrorToast("Image rotation failed");
        }
        return response;
    }

    const rotateImageQuery = useQuery("rotate-image", rotateImageFn, {...useQueryConfiguration});

    useEffect(() => {
        if(rotateImageQuery.isSuccess) {
            rotateImageQuery.remove();
            props.closePopup();
        }
    }, [rotateImageQuery.isSuccess])

    const handleFooterIcons = (action) => {

        if(_.isEqual(action, "LEFT")) {
            setUtils({ ...utils, rotation: utils.rotation === 0 ? 270 : utils.rotation - 90 });
            ref?.current?.resetTransform(300);
        }
        else if(_.isEqual(action, "RIGHT")) {
            setUtils({ ...utils, rotation: utils.rotation === 270 ? 0 : utils.rotation + 90 });
            ref?.current?.resetTransform(300);
        }
        else {
            rotateImageQuery.refetch();
        }
    }

    return (
        <Modal backdrop="static" onHide={() => props.closePopup()} size="lg" show={true}>
            {
                rotateImageQuery.isFetching ?
                    <div className="text-center">
                        <ClipLoader className="my-5 mx-5" color="#075978" />
                    </div>
                        :
                    <TransformWrapper
                        ref={ref}
                        wheel={{ step: 0.11 }}
                        zoomAnimation={{ animationTime: 600, animationType: "easeOut" }}
                        doubleClick={{ disabled: true }}
                    >
                        {
                            ({ zoomIn, zoomOut, resetTransform, ...rest }) => 
                                <>
                                    <Modal.Header closeButton className="m-0 p-2" />

                                    <Modal.Body className="m-0 p-0">
                                        <TransformComponent contentClass="w-100 d-flex justify-content-center" wrapperClass="w-100">
                                            <div style={{ rotate: `${utils.rotation}deg`, scale: "0.7" }}>
                                                <ReactImageGallery
                                                    showFullscreenButton={false}
                                                    showPlayButton={false}
                                                    items={[{ original: props.image, originalHeight: "500", originalWidth: "500" }]}
                                                />
                                            </div>
                                        </TransformComponent>
                                    </Modal.Body>
                                </>
                        }
                    </TransformWrapper>
            }
            {
                !rotateImageQuery.isFetching &&
                    <Modal.Footer className="text-center w-100">
                        <Row style={{ display: "flex", alignItems: "center", justifyContent: "center" }} className="w-100">
                            <Col xl={2} xs={2} sm={2} md={2} lg={2}>
                                <Icon className="cursor-pointer" onClick={() => handleFooterIcons("LEFT")} width={20} height={20} icon={"feather-rotate-ccw"} />
                            </Col>
                            <Col xl={2} xs={2} sm={2} md={2} lg={2}>
                                <Icon onClick={() => ref?.current?.zoomOut()} className="cursor-pointer" icon={"feather-zoom-out"} width={20} height={20} />
                            </Col>
                            <Col xl={2} xs={2} sm={2} md={2} lg={2}>
                                <Button onClick={() => handleFooterIcons()} disabled={utils.rotation === 0 || isLockedProfile || isEditOngoing}>Save</Button>
                            </Col>
                            <Col xl={2} xs={2} sm={2} md={2} lg={2}>
                                <Icon onClick={() => ref?.current?.zoomIn()} className="cursor-pointer" icon={"feather-zoom-in"} width={20} height={20} />
                            </Col>
                            <Col xl={2} xs={2} sm={2} md={2} lg={2}>
                                <Icon className="cursor-pointer" onClick={() => handleFooterIcons("RIGHT")} width={20} height={20} icon={"feather-rotate-cw"} />
                            </Col>
                        </Row>
                    </Modal.Footer>
            }
        </Modal>
    )

}

export default ImagePopup;